import { create } from 'zustand';

export type QueryPositionValue = number | string;

interface QueryPositionState {
    positions: Record<string, QueryPositionValue>; // not sure if this is a number or a stringified number
}

export const useQueryPositionStore = create<QueryPositionState>()(() => ({
    positions: {},
}));

export const setQueryPosition = (key: string, value: QueryPositionValue) => {
    useQueryPositionStore.setState((state) => {
        return { ...state, positions: { ...state.positions, [key]: value } };
    });
};

export const getQueryPosition = (key: string) => {
    return useQueryPositionStore.getState().positions[key];
};

export const removeQueryPosition = (key: string) => {
    useQueryPositionStore.setState((state) => {
        const newPositions = { ...state.positions };
        delete newPositions[key];
        return { ...state, positions: newPositions };
    });
};
